import Api from "./PreApiHandler";
import RawApi from "./api";

export default {
    index,
    view,
    viewSilent,
    create,
    update,
    copy,
    execute,
    delete: actionDelete
};

async function index(params = {}) {
    const request = {
        method: 'get',
        path: 'report/user-report/index',
        params
    }
    return Api.sendRequest(request)
}

async function view(uuid, { suppressAccessDenied = false, signal = null } = {}) {
    const request = {
        method: 'get',
        path: 'report/user-report/view',
        params: { uuid },
        suppressAccessDenied,
        signal
    }
    return Api.sendRequest(request)
}

async function viewSilent(uuid) {
    try {
        return await RawApi.sendRequest({
            method: 'get',
            path: 'report/user-report/view',
            params: { uuid }
        });
    } catch (e) {
        return null;
    }
}

async function create(body) {
    const request = {
        method: 'post',
        path: 'report/user-report/create',
        body
    }
    return Api.sendRequest(request)
}

async function update(uuid, body) {
    const request = {
        method: 'post',
        path: 'report/user-report/update',
        params: { uuid },
        body
    }
    return Api.sendRequest(request)
}

async function copy(uuid) {
    const request = {
        method: 'post',
        path: 'report/user-report/copy',
        params: { uuid }
    }
    return Api.sendRequest(request)
}

async function execute(uuid, body = {}, { suppressAccessDenied = false, signal = null } = {}) {
    const request = {
        method: 'post',
        path: 'report/user-report/execute',
        params: { uuid },
        body,
        suppressAccessDenied,
        signal
    }
    return Api.sendRequest(request)
}

async function actionDelete(uuid) {
    const request = {
        method: 'post',
        path: 'report/user-report/delete',
        params: { uuid }
    }
    return Api.sendRequest(request)
}
